webpackJsonp([1],{

/***/ 171:
/*!*********************!*\
  !*** ./src/App.vue ***!
  \*********************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f57db002","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 172)
}
var Component = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 174),
  /* template */
  __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f57db002","hasScoped":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f57db002","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 175:
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f57db002","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue ***!
  \********************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    attrs: {
      "language": "language"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 177:
/*!********************************************!*\
  !*** ./src/components/layouts/Default.vue ***!
  \********************************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-10528294","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Default.vue */ 178)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Default.vue */ 179),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-10528294","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Default.vue */ 209),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10528294","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/Default.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/Default.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(/*! ../../firebase-config.js */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: "",
      live: "",
      promotionsData: [],
      unpublishedPromoId: ""
    };
  },
  computed: {
    $lang: function $lang() {
      return this.$store.state.$lang;
    }
  },
  created: function created() {
    var user = __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["firebase"].auth().currentUser;
    var name = void 0,
        email = void 0,
        photoUrl = void 0,
        emailVerified = void 0;

    if (user != null) {
      name = user.displayName;
      email = user.email;
      photoUrl = user.photoURL;
      emailVerified = user.emailVerified;
    }

    this.email = email;
  },

  methods: {
    update$lang: function update$lang(newLang) {
      console.log("update");
      localStorage.setItem("lang", newLang);
      return this.$store.commit("update$lang", newLang);
    },
    unpublishedPromo: function unpublishedPromo() {
      var _this = this;

      this.$prompt("Enter Promo ID (ex: 4DCY3KSUXLLU3)", "Unpublished promo", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPattern: /^[a-zA-Z0-9]{10,14}$/,
        inputErrorMessage: "Promo ID is not valid"
      }).then(function (_ref) {
        var value = _ref.value;

        _this.$router.push({ path: "/update/" + value });
        _this.$message({
          type: "success",
          message: "Promo succesfully loaded."
        });
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "Input canceled"
        });
      });
    },
    logout: function logout() {
      var _this2 = this;

      this.$confirm("Are you sure you want to logout?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        _this2.$router.push({ path: "logout" });
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Logout is canceld."
        });
      });
    },
    publishData: function publishData(type) {
      var _this3 = this;

      this.promotionsData = [];
      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].get().then(function (querySnapshot) {
        _this3.loading = false;
        querySnapshot.forEach(function (doc) {
          console.log(doc.data());
          console.log(doc.data().lang);
          if (doc.data().lang === _this3.$lang) {
            var data = {
              promotionId: doc.data().promotionId,
              models: doc.data().models,
              codes: doc.data().codes,
              active: doc.data().active,
              squareHeader: doc.data().squareHeader || false,
              squareSecondary: doc.data().squareSecondary || false,
              noPurchaseOptions: doc.data().noPurchaseOptions || false
            };
            _this3.promotionsData.push(data);
          }
        });

        console.log(_this3.promotionsData);

        if (type === "live") {
          _this3.$confirm("Are you sure you want to publish?", "Warning", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }).then(function () {
            console.log("live publish");
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("./publish/" + _this3.$lang + "/publish-live.php", _this3.promotionsData).then(function (data) {
              console.log("publish live");
              var live = false;

              _this3.$message({
                type: "success",
                message: "Het publiceren is gelukt."
              });
            }).catch(function (error) {
              console.log(error);

              _this3.$message({
                type: "error",
                message: "Het publiceren is mislukt."
              });
            });
          }).catch(function () {
            _this3.$message({
              type: "info",
              message: "Het publiceren is geannuleerd."
            });
          });
        } else if (type === "staging") {
          _this3.$confirm("Weet je zeker dat je wilt dit wilt publiceren naar staging?", "Waarschuwing", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          }).then(function () {
            console.log("staging publish");
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("./publish/" + _this3.$lang + "/publish-staging.php", _this3.promotionsData).then(function (data) {
              console.log("publish staging");
              var live = true;

              _this3.$message({
                type: "success",
                message: "Het publiceren is gelukt."
              });
            }).catch(function (error) {
              console.log(error);

              _this3.$message({
                type: "error",
                message: "Het publiceren is mislukt."
              });
            });
          }).catch(function () {
            _this3.$message({
              type: "info",
              message: "Het publiceren is geannuleerd."
            });
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 209:
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10528294","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Default.vue ***!
  \*******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticStyle: {
      "height": "100%",
      "border": "1px solid #eee"
    }
  }, [_c('el-aside', {
    attrs: {
      "width": "260px"
    }
  }, [_c('el-menu', {
    attrs: {
      "default-openeds": ['1'],
      "theme": "dark"
    }
  }, [_c('div', {
    staticClass: "brand"
  }, [_vm._v("Samsung Promotool")]), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" Dashboard")])], 1)], 1), _vm._v(" "), _c('el-menu-item-group', [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    on: {
      "click": _vm.unpublishedPromo
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" Unpublished Promo")])])], 1)], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-header', {
    staticStyle: {
      "text-align": "right",
      "font-size": "12px",
      "height": "auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.publishData('staging')
      }
    }
  }, [_vm._v("Publish Staging")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.publishData('live')
      }
    }
  }, [_vm._v("Publish Live")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "lang"
  }, [_vm._v(_vm._s(_vm.$lang))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    staticStyle: {
      "margin-right": "15px"
    }
  }), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('nl')
      }
    }
  }, [_vm._v("NL")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('be')
      }
    }
  }, [_vm._v("BE")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.update$lang('be_fr')
      }
    }
  }, [_vm._v("BE_FR")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1)], 1), _vm._v(" "), _c('el-main', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 210:
/*!****************************!*\
  !*** ./src/views/Home.vue ***!
  \****************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2fdf881c","scoped":false,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 211)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 212),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2fdf881c","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 214),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fdf881c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Home.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(/*! ../store */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      promotions: [],
      language: "nl",
      loading: true,
      titles: [{
        prop: "configId",
        label: "Config ID",
        width: "100"
      }, {
        prop: "id",
        label: "ID",
        width: "130"
      }, {
        prop: "title",
        label: "Titel"
      }, {
        prop: "period",
        label: "Periode",
        width: "170"
      }],
      filters: [{
        prop: "promotionEnded",
        value: false
      }, {
        value: "",
        prop: "title"
      }, {
        value: "",
        prop: "id"
      }, {
        value: "",
        prop: "configId"
      }],
      formOptions: {
        inline: true,
        submitBtnText: "Zoeken",
        forms: [{ prop: "title", label: "Titel" }, { prop: "id", label: "ID" }, { prop: "configId", label: "Config ID" }, {
          prop: "promotionEnded",
          label: "Periode",
          itemType: "select",
          options: [{ value: "", label: "All" }, { value: false, label: "Actueel" }, { value: true, label: "Archief" }]
        }]
      },
      columns: [{ prop: "configId", label: "Config Id", width: "80" }, { prop: "id", label: "id" }, { prop: "title", label: "Titel", width: "auto" }, { prop: "period", label: "Periode", width: "200", filter: false }, { prop: "id", label: "Edit", slotName: "rowEdit" }],
      now: ""
    };
  },
  watch: {
    $lang: function $lang() {
      this.getData();
    }
  },
  mounted: function mounted() {
    this.getData();
    // var jobskill_query = promotionsCollection.where(
    //   "promotionId",
    //   "==",
    //   "FX5YQB344AD84"
    // );
    // jobskill_query.get().then(function(querySnapshot) {
    //   querySnapshot.forEach(function(doc) {
    //     doc.ref.delete();
    //   });
    // });
    // console.log(jobskill_query, "jobskill_query");
  },

  methods: {
    getData: function getData() {
      var _this = this;

      console.log("getdata");
      this.promotions = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://sebnapi.nl/promo/" + this.$lang + "/cached/promotions.json").then(function (data) {
        console.log("mounted");

        data.data.forEach(function (item) {
          var conditionalDate = item.item.participationEndDate.split("-");
          var promotionEnded = false;

          var period = item.item.startDate + " / " + item.item.endDate;
          _this.loading = false;

          var date = new Date();
          var day = (date.getDate() < 10 ? "0" : "") + date.getDate();
          var month = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
          var year = date.getFullYear();
          _this.now = "" + year + month + day;

          var endDate = item.item.endDate.split("-");
          var conditionalEndDate = endDate[2] + ("0" + endDate[1]).slice(-2) + ("0" + endDate[0]).slice(-2);

          if (_this.now > conditionalEndDate) {
            promotionEnded = true;
          } else {
            promotionEnded = false;
          }
          if (item.item.isActive) {
            console.log("item", item);
            __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].onSnapshot(function (promotionsRef) {
              __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].where("promotionId", "==", item.item.id).get().then(function (querySnapshot) {
                _this.loading = false;
                if (querySnapshot.docs.length === 1) {
                  querySnapshot.forEach(function (doc) {
                    _this.promotions.push({
                      id: item.item.id,
                      configId: _this.getConfigValue(item.item.ConfigValues, "SortCarousel"),
                      title: item.item.title,
                      category: item.item.category,
                      image: item.item.image,
                      isActive: item.item.isActive,
                      promotionMicrositeTitle: item.item.promotionMicrositeTitle,
                      promotionMicrositeDescription: item.item.PromotionMicrositeDescription,
                      IsForSamsungMembers: item.item.isForSamsungMembers,
                      IsPreview: item.item.isPreview,
                      staticUrl: _this.getConfigValue(item.item.ConfigValues, "StaticUrl"),
                      startDate: item.item.startDate,
                      period: period,
                      endDate: item.item.endDate,
                      promotionEnded: promotionEnded,
                      participationStartDate: item.item.participationStartDate,
                      participationEndDate: item.item.participationEndDate,
                      conditionalDate: conditionalDate[2] + conditionalDate[1] + conditionalDate[0],
                      created: true
                    });
                  });
                } else {
                  _this.promotions.push({
                    id: item.item.id,
                    configId: _this.getConfigValue(item.item.ConfigValues, "SortCarousel"),
                    title: item.item.title,
                    category: item.item.category,
                    image: item.item.image,
                    isActive: item.item.isActive,
                    promotionMicrositeTitle: item.item.promotionMicrositeTitle,
                    promotionMicrositeDescription: item.item.PromotionMicrositeDescription,
                    IsForSamsungMembers: item.item.isForSamsungMembers,
                    IsPreview: item.item.isPreview,
                    staticUrl: _this.getConfigValue(item.item.ConfigValues, "StaticUrl"),
                    startDate: item.item.startDate,
                    period: period,
                    endDate: item.item.endDate,
                    promotionEnded: promotionEnded,
                    participationStartDate: item.item.participationStartDate,
                    participationEndDate: item.item.participationEndDate,
                    conditionalDate: conditionalDate[2] + conditionalDate[1] + conditionalDate[0],
                    created: false
                  });
                }
              });
            });
          }
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push("/update/" + row.id);
    },
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;

      this.$confirm("Weet je zeker dat je dit item wilt verwijderen?", "Waarschuwing", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        // recieve items in document
        __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].where("promotionId", "==", row.id).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].doc(doc.id).collection("models").get().then(function (querySnapshot) {
              querySnapshot.forEach(function (model) {
                __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].doc(doc.id).collection("models").doc(model.id).delete().then(function (doc) {
                  console.log("Sub collection model successfully deleted!");
                }).catch(function (error) {
                  console.log("error");
                });
              });
            });

            __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].doc(doc.id).collection("codes").get().then(function (querySnapshot) {
              querySnapshot.forEach(function (model) {
                __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].doc(doc.id).collection("codes").doc(model.id).delete().then(function (doc) {
                  console.log("Sub collection codes successfully deleted!");
                  _this2.getData();
                }).catch(function (error) {
                  console.log("error");
                });
              });
            });

            __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["promotionsCollection"].doc(doc.id).delete().then(function (doc) {
              console.log("Document successfully deleted!");
              _this2.$message({
                type: "success",
                message: "Het item is succesvol verwijderd!"
              });
              _this2.getData();
            }).catch(function (error) {
              console.error("Error removing document: ", error);
              this.$message({
                type: "error",
                message: "Er is iets mis gegaan. Probeer het nogmaals."
              });
            });
          });
        });
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "Het verwijderen is geannuleerd."
        });
      });
    },
    filterTag: function filterTag(value, row) {
      //return row.availableDevices === value;
    },
    filterHandler: function filterHandler(value, row, column) {
      var property = column["property"];
      return row[property] === value;
    },

    getConfigValue: function getConfigValue(data, field) {
      var value = data.filter(function (config) {
        return config.ConfigValueName === field;
      });

      if (typeof value !== "undefined" && value.length > 0) {
        return value[0].ConfigValueValue;
      } else {
        return false;
      }
    }
  },
  computed: {
    $lang: function $lang() {
      return this.$store.state.$lang;
    }
  }
});

/***/ }),

/***/ 214:
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdf881c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue ***!
  \***************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('el-row', {
    staticClass: "margin-bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Zoek op titel.."
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("Archief")])], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.promotions,
      "pagination-props": {
        pageSizes: [20, 40, 60]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.label,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom",
        "width": title.width
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Preview",
      "min-width": "170px",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": ("https://www.samsung.com/nl/promo/promo/?id=" + (scope.row.id)),
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("STAGING")])], 1), _vm._v(" "), _c('a', {
          attrs: {
            "href": ("https://qaweb.samsung.com/nl/promo/promo/?id=" + (scope.row.id)),
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("LIVE")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "100px",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.staticUrl !== false) ? _c('div', [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("STATIC URL")])], 1) : _vm._e(), _vm._v(" "), (scope.row.created === true) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.created === false) ? _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.staticUrl === false),
            expression: "scope.row.staticUrl === false"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-circle-plus"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 215:
/*!***************************!*\
  !*** ./src/views/Add.vue ***!
  \***************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1ebbeb5e","scoped":false,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Add.vue */ 216)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Add.vue */ 217),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1ebbeb5e","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Add.vue */ 221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ebbeb5e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Add.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Add.vue ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_popups_Bulk_popup_vue__ = __webpack_require__(/*! ../components/popups/Bulk-popup.vue */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_popups_Bulk_popup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_popups_Bulk_popup_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var fb = __webpack_require__(/*! ../firebase-config.js */ 5);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      path: this.$route.path,
      promotionId: null,
      promoTitle: "",
      input: null,
      models: [],
      codes: [],
      promotionRecordId: null,
      promotionsData: [],
      addBulk: false,
      bulk: [],
      loading: false,
      squareSecondary: false,
      squareHeader: false,
      noPurchaseOptions: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.promotionId = this.$route.params.id;
    this.models = [];
    console.log(this.$route.params.id);

    // recieve items in document
    __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].onSnapshot(function (promotionRef) {
      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].where("promotionId", "==", _this.promotionId).get().then(function (querySnapshot) {
        console.log(querySnapshot, "querySnapshot");
        if (querySnapshot.docs.length === 1) {
          querySnapshot.forEach(function (doc) {
            _this.promotionRecordId = doc.id;
            _this.models = doc.data().models;
            _this.codes = doc.data().codes;
            _this.squareHeader = doc.data().squareHeader || false;
            _this.squareSecondary = doc.data().squareSecondary || false;
            _this.noPurchaseOptions = doc.data().noPurchaseOptions || false;
          });
        } else {
          console.log("doesnt exist");
          var promotionId = _this.promotionId;
          var models = [];
          var codes = [];
          var active = true;
          var squareHeader = false;
          var squareSecondary = false;
          var noPurchaseOptions = false;
          var createdAt = new Date();

          __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].add({
            promotionId: promotionId,
            models: models,
            codes: codes,
            active: active,
            createdAt: createdAt,
            squareHeader: squareHeader,
            squareSecondary: squareSecondary,
            noPurchaseOptions: noPurchaseOptions
          }).then(function (docRef) {
            console.log("Document written with ID: ", docRef.id);
            this.promotionRecordId = docRef.id;
          }).catch(function (error) {
            console.error("Error adding document: ", error);
          });
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sebnapi.nl/promo/" + this.$store.state.$lang + "/cached/promotions/" + this.promotionId + ".json").then(function (data) {
      var promoDataContents = data.data.GetPromotionDetailsResult.Contents;
      _this.promoTitle = _this.getContent(promoDataContents, "Text", "Value", "Title");
    });
  },

  methods: {
    openBulk: function openBulk() {
      this.addBulk = true;
    },
    addBulkModels: function addBulkModels() {
      var bulk = this.bulk;
      var lines = bulk.split(/\n/);
      var output = [];
      var outputText = [];
      for (var i = 0; i < lines.length; i++) {
        if (/\S/.test(lines[i])) {
          this.models.push({
            show: true,
            active: true,
            sku: lines[i]
          });
        }
      }

      this.addBulk = false;
    },
    handleClose: function handleClose(done) {
      this.$confirm("Weet je zeker dat je dit wilt cancelen?").then(function (_) {
        done();
      }).catch(function (_) {});
    },
    addRowModels: function addRowModels(index) {
      this.models.push({
        show: true,
        active: true,
        sku: null
      });
    },
    addRowCodes: function addRowCodes(index) {
      this.codes.push({
        show: true
      });
    },
    deleteRowModels: function deleteRowModels(index) {
      this.models.splice(index, 1);
    },
    deleteRowCodes: function deleteRowCodes(index) {
      this.codes.splice(index, 1);
    },
    toggleRowModels: function toggleRowModels(index) {
      this.models[index].show = !this.models[index].show;

      if (this.models[index].active === undefined) {
        this.models[index].active = true;
      }
    },
    toggleRowCodes: function toggleRowCodes(index) {
      this.codes[index].show = !this.codes[index].show;
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    toggleActief: function toggleActief() {
      this.newUpdate.actief = !this.newUpdate.actief;
    },
    success_message: function success_message() {
      this.$notify({
        title: "Success",
        message: "Succesvol toegevoegd.",
        type: "success"
      });
    },
    error_message: function error_message() {
      this.$notify.error({
        title: "Error",
        message: "Er is iets mis gegaan."
      });
    },
    getProductName: function getProductName(sku) {
      var productName = "";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.samsung.com/model?key=D836F2310FDB43309FD65C433D5F8DE8&modelCode=" + sku + "&type=json&iaType=consumer&siteCode=nl").then(function (data) {
        var resultData = data.data.response.resultData;
        if (data.data.response.resultData !== "no data found") {
          return "Bestaat niet";
        } else {
          console.log("test");
          return data.data.response.resultData.Products.Product.BasicInfo[0].DisplayName;
          console.log(data.data.response.resultData.Products.Product.BasicInfo[0].DisplayName);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    getContent: function getContent(data, row, value, field) {
      var contentData = data.filter(function (item) {
        return item.Text === field;
      });

      return contentData[0].Value;
    },
    onSubmit: function onSubmit() {
      console.log(this.promotionRecordId);
      var createdAt = new Date();
      var promotionId = this.promotionId;
      var promotionRecordId = this.promotionRecordId;
      var lang = this.$store.state.$lang;
      var actief = this.actief;
      var models = this.models;
      var codes = this.codes;
      var active = true;
      var path = this.$route.path;
      var squareSecondary = this.squareSecondary;
      var squareHeader = this.squareHeader;
      var noPurchaseOptions = this.noPurchaseOptions;

      console.log("update");
      console.log(promotionRecordId);

      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].doc(promotionRecordId).set({
        promotionId: promotionId,
        lang: lang,
        models: models,
        codes: codes,
        active: active,
        createdAt: createdAt,
        squareSecondary: squareSecondary,
        squareHeader: squareHeader,
        noPurchaseOptions: noPurchaseOptions
      }, { merge: true }).then(function (docRef) {
        console.log("Document written with ID: ", promotionRecordId);

        /*
        models.forEach((item) => {
          let sku = item.sku
          let active = true
           promotionsCollection.doc(promotionRecordId).collection("models").add({
            sku,
            active,
          })
        });
         codes.forEach((item) => {
          let title = item.title
          let text = item.text
          let active = true
           promotionsCollection.doc(promotionRecordId).collection("codes").add({
            title,
            text,
            active
          })
        });
        */
      }).catch(function (error) {
        console.error("Error adding document: ", error);
      });
      this.success_message();
    }
  }
});

/***/ }),

/***/ 218:
/*!**********************************************!*\
  !*** ./src/components/popups/Bulk-popup.vue ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Bulk-popup.vue */ 219),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-119668d2","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Bulk-popup.vue */ 220),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/popups/Bulk-popup.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      bulk: ''
    };
  },
  methods: {
    addModels: function addModels(index) {
      var bulk = this.bulk;

      var lines = bulk.split(/\n/);
      var output = [];
      var outputText = [];
      for (var i = 0; i < lines.length; i++) {
        if (/\S/.test(lines[i])) {
          //outputText.push('"' + $.trim(lines[i]) + '"');
          //output.push($.trim(lines[i]));
          this.models.push({
            show: true,
            sku: lines[i]
          });
        }
      }
    }
  }
});

/***/ }),

/***/ 220:
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119668d2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Bulk-popup.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.deleteRow(_vm.index)
      }
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Bulk add"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addModels
    }
  }, [_vm._v("Toevoegen")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 221:
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebbeb5e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Add.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.promoTitle))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "interface-settings"
  }, [_c('h2', [_vm._v("Interface settings")]), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("Square header image")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.squareHeader),
      callback: function($$v) {
        _vm.squareHeader = $$v
      },
      expression: "squareHeader"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("Square lifestyle/product image")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.squareSecondary),
      callback: function($$v) {
        _vm.squareSecondary = $$v
      },
      expression: "squareSecondary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui-row"
  }, [_c('span', [_vm._v("No purchase options available")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.noPurchaseOptions),
      callback: function($$v) {
        _vm.noPurchaseOptions = $$v
      },
      expression: "noPurchaseOptions"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-add"
  }, [_c('div', {
    staticClass: "col-left"
  }, [_c('h2', [_vm._v("Models")]), _vm._v(" "), _vm._l((_vm.models), function(model, index) {
    return _c('el-card', {
      key: ("input-" + index),
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "header_item clearfix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowModels(index)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(model.sku))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin-top": "14px"
      },
      attrs: {
        "button": "",
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteRowModels(index)
        }
      }
    })], 1), _vm._v(" "), (model.show) ? _c('div', [_c('ul', [_c('li', [_c('el-form-item', {
      attrs: {
        "label": "SKU"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "SKU"
      },
      model: {
        value: (model.sku),
        callback: function($$v) {
          _vm.$set(model, "sku", $$v)
        },
        expression: "model.sku"
      }
    }, [_vm._v(_vm._s(model.sku))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Aan / Uit"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      model: {
        value: (model.active),
        callback: function($$v) {
          _vm.$set(model, "active", $$v)
        },
        expression: "model.active"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "size": "large"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowModels(index)
        }
      }
    }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteRowModels(index)
        }
      }
    }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e()])
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.addRowModels
    }
  }, [_vm._v("Add new")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.openBulk
    }
  }, [_vm._v("Add Bulk")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-right"
  }, [_c('h2', [_vm._v("Model list")]), _vm._v(" "), _vm._l((_vm.codes), function(input, index) {
    return _c('el-card', {
      key: ("input-" + index),
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "header_item clearfix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowCodes(index)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(input.title))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin-top": "14px"
      },
      attrs: {
        "button": "",
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteRowCodes(index)
        }
      }
    })], 1), _vm._v(" "), (input.show) ? _c('div', [_c('ul', [_c('li', [_c('el-form-item', {
      attrs: {
        "label": "Titel"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Titel"
      },
      model: {
        value: (input.title),
        callback: function($$v) {
          _vm.$set(input, "title", $$v)
        },
        expression: "input.title"
      }
    }, [_vm._v(" - " + _vm._s(input.title))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Codes"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "codes..",
        "rows": "10"
      },
      model: {
        value: (input.text),
        callback: function($$v) {
          _vm.$set(input, "text", $$v)
        },
        expression: "input.text"
      }
    }, [_vm._v(" - " + _vm._s(input.text))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "size": "large"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.toggleRowCodes(index)
        }
      }
    }, [_vm._v("Opslaan")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteRowCodes(index)
        }
      }
    }, [_vm._v("Cancel")])], 1)], 1)])]) : _vm._e()])
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.addRowCodes
    }
  }, [_vm._v("Add new")])], 1)], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Bulk toevoegen",
      "visible": _vm.addBulk,
      "width": "50%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.addBulk = $event
      }
    }
  }, [_c('el-form', [_c('p', [_vm._v("Add on every line a new model.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Modelcodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 10
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBulkModels
    }
  }, [_vm._v("Add")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 222:
/*!****************************!*\
  !*** ./src/views/Data.vue ***!
  \****************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Data.vue */ 223),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6fadd93d","hasScoped":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Data.vue */ 224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 223:
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Data.vue ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      promotions: []
    };
  },
  methods: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].onSnapshot(function (promotionsRef) {
      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["promotionsCollection"].get().then(function (querySnapshot) {
        _this.loading = false;
        querySnapshot.forEach(function (doc) {

          var data = {
            'promotionId': doc.data().promotionId,
            'models': doc.data().models,
            'codes': doc.data().codes,
            'active': doc.data().active
          };
          _this.promotions.push(data);
        });
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('publish/publish-live.php', _this.promotions).then(function (data) {
          console.log('publish live');
        }).catch(function (error) {
          console.log(error);
        });
      });
    });
  }
});

/***/ }),

/***/ 224:
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fadd93d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Data.vue ***!
  \***************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(this.promotions) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 225:
/*!*****************************!*\
  !*** ./src/views/Login.vue ***!
  \*****************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-37dc28e6","scoped":true,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Login.vue */ 226)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Login.vue */ 227),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-37dc28e6","hasScoped":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Login.vue */ 228),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37dc28e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37dc28e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Login.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Login.vue ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    signIn: function signIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["firebase"].auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.$router.replace('/');
      }, function (err) {
        _this.$notify.error({
          title: 'Error',
          message: err.message
        });
      });
    }
  }
});

/***/ }),

/***/ 228:
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37dc28e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue ***!
  \***************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h4', [_vm._v("Samsung Promotool")]), _vm._v(" "), _c('div', {
    staticClass: "login-inner"
  }, [_c('h3', [_vm._v("Inloggen")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Wachtwoord"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.signIn,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("Inloggen")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 229:
/*!******************************!*\
  !*** ./src/views/Logout.vue ***!
  \******************************/
/*! no static exports found */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-10b9fc5d","scoped":true,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Logout.vue */ 230)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 7)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Logout.vue */ 231),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-10b9fc5d","hasScoped":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Logout.vue */ 232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10b9fc5d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10b9fc5d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Logout.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Logout.vue ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index_js__ = __webpack_require__(/*! ../router/index.js */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["firebase"].auth().signOut().then(function () {
      __WEBPACK_IMPORTED_MODULE_0__router_index_js__["a" /* default */].push({ path: 'login' });
    }, function (error) {
      this.$notify.error({
        title: 'Error',
        message: err.message
      });
    });
  }
});

/***/ }),

/***/ 232:
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b9fc5d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Logout.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 234:
/*!**************************!*\
  !*** ./src/utils/pwa.js ***!
  \**************************/
/*! exports provided:  */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),

/***/ 236:
/*!**************************************************************************!*\
  !*** ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff ***!
  \**************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/element-icons.2fad952a.woff";

/***/ }),

/***/ 237:
/*!*************************************************************************!*\
  !*** ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf ***!
  \*************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/element-icons.6f0a7632.ttf";

/***/ }),

/***/ 5:
/*!********************************!*\
  !*** ./src/firebase-config.js ***!
  \********************************/
/*! exports provided: firebase, db, promotionsCollection */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "promotionsCollection", function() { return promotionsCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuefire__ = __webpack_require__(/*! vuefire */ 198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(/*! firebase/app */ 199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_firestore__ = __webpack_require__(/*! firebase/firestore */ 203);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a; });



__webpack_require__(/*! firebase/auth */ 207);

var config = {
  apiKey: "AIzaSyB_6VjrJXmDGPXUy82weBfj13SmbyDPw2c",
  authDomain: "promotool-120ef.firebaseapp.com",
  databaseURL: "https://promotool-120ef.firebaseio.com",
  projectId: "promotool-120ef",
  storageBucket: "promotool-120ef.appspot.com",
  messagingSenderId: "46361293468"
};

__WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.initializeApp(config);
var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.firestore();
var settings = {
  timestampsInSnapshots: true
};
db.settings(settings);

// to use development, set to true production = false
var dev = false;

var promotionsCollection = void 0;

if (dev === true) {
  promotionsCollection = db.collection("promotions_dev");
} else {
  promotionsCollection = db.collection("promotions");
}



/***/ }),

/***/ 75:
/*!*****************************!*\
  !*** ./src/router/index.js ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Default__ = __webpack_require__(/*! ../components/layouts/Default */ 177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layouts_Default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layouts_Default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__(/*! ../views/Home */ 210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Add__ = __webpack_require__(/*! ../views/Add */ 215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Data__ = __webpack_require__(/*! ../views/Data */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Login__ = __webpack_require__(/*! ../views/Login */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Logout__ = __webpack_require__(/*! ../views/Logout */ 229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase_config_js__ = __webpack_require__(/*! ../firebase-config.js */ 5);










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    title: 'login',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Login___default.a
  }, {
    path: '/logout',
    title: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Logout___default.a,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/data',
    title: 'Data',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Data___default.a,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_layouts_Default___default.a,
    children: [{
      path: '/login',
      title: 'login',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Login___default.a
    }, {
      path: '/add',
      title: 'Add',
      component: __WEBPACK_IMPORTED_MODULE_4__views_Add___default.a,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/login',
      title: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_5__views_Data___default.a,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/update/:id',
      title: 'Update',
      component: __WEBPACK_IMPORTED_MODULE_4__views_Add___default.a,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/',
      title: 'Start',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Home___default.a,
      meta: {
        requiresAuth: true
      }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_8__firebase_config_js__["firebase"].auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });

  if (requiresAuth && !currentUser) router.push({ path: 'Login' });else if (to.path === '/data') next();else if (!requiresAuth && currentUser) next('/');else next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 82:
/*!****************************!*\
  !*** ./src/store/index.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 213);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var lang = 'nl';
if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang');
}

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    $lang: lang
  },
  mutations: {
    update$lang: function update$lang(state, newLang) {
      state.$lang = newLang;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 83:
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided:  */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_promise_polyfill__ = __webpack_require__(/*! ./utils/promise-polyfill */ 84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables__ = __webpack_require__(/*! vue-data-tables */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__(/*! element-ui/lib/locale/lang/en */ 89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(/*! element-ui */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(/*! element-ui/lib/theme-chalk/index.css */ 170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(/*! ./App */ 171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(/*! ./router */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(/*! ./store */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_config_js__ = __webpack_require__(/*! firebase-config.js */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_modal__ = __webpack_require__(/*! vue-js-modal */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_js_modal__);





__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default.a);




__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Autocomplete"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DropdownMenu"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DropdownItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["MenuItemGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Input"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["InputNumber"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Radio"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["RadioGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["RadioButton"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Checkbox"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CheckboxButton"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CheckboxGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Switch"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["OptionGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Button"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["ButtonGroup"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Table"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TableColumn"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TimeSelect"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TimePicker"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tooltip"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Form"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["FormItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tag"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tree"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Alert"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Icon"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Row"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Col"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["CollapseItem"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Cascader"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Container"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Header"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Main"]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Footer"]);

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Loading"].directive);

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$loading = __WEBPACK_IMPORTED_MODULE_5_element_ui__["Loading"].service;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$msgbox = __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"];
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$alert = __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"].alert;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$confirm = __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"].confirm;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$prompt = __WEBPACK_IMPORTED_MODULE_5_element_ui__["MessageBox"].prompt;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$notify = __WEBPACK_IMPORTED_MODULE_5_element_ui__["Notification"];
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$message = __WEBPACK_IMPORTED_MODULE_5_element_ui__["Message"];









__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_js_modal___default.a, {
  dynamic: true
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a });
Object(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(/*! ./utils/pwa */ 234);
}

var app = void 0;

__WEBPACK_IMPORTED_MODULE_10_firebase_config_js__["firebase"].auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({ // eslint-disable-line no-new
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
      store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
      data: function data() {
        return {
          title: 'Start'
        };
      },

      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_7__App___default.a }
    });
  }
});

/***/ }),

/***/ 84:
/*!***************************************!*\
  !*** ./src/utils/promise-polyfill.js ***!
  \***************************************/
/*! exports provided:  */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ })

},[83]);


// WEBPACK FOOTER //
// app.ecfb498e.js